export enum INTERVIEW_STATUS {
  TODO,
  DONE,
  ALL,
}

export const LIST_SKELETON_LENGTH = 10;

export const DEFAULT_COMPANY_ID = 1;

export enum PROJECT_ROLES {
  ADMIN = 'ADMIN',
  ANALYST = 'ANALYST',
  INTERVIEWER = 'INTERVIEWER',
  UNDEFINED = 'UNDEFINED',
  READ_ONLY = 'READ_ONLY',
}

export const PROJECT_ROLE_KEYS: Record<PROJECT_ROLES, string> = {
  ADMIN: 'CvaProj.Home1',
  ANALYST: 'CvaProj.Home3',
  INTERVIEWER: 'CvaInput.SegPage24',
  READ_ONLY: 'CvaInput.Home33',
  UNDEFINED: 'CvaInput.Home32',
};

export const DEFAULT_DATE = 11;

export enum SORT_TYPES {
  COMPANY = 'companyName',
  PROJECT = 'description',
  DATE = 'createdDate',
}

export const ROLE_TOOLTIP = ['CvaProj.StaffDlg3', 'CvaProj.StaffDlg4', 'CvaProj.StaffDlg5', 'CvaProj.StaffDlg6'];
